<template>
    <header class="edit_parent_header edit_program_header" v-if="!hide_head">
        Parent / Guardian Consent
        <Switch :checked="is_need" @click.native="is_show_alert_modal = true;" />
        <i @click="close()"><svg-icon name="close" /></i>
    </header>

    <div class="edit-scroll-list edit-parent-box" v-if="handle_data.length > 0">
        <div class="edit_program_body">
            <div class="box question-templeat">
                <!-- Introduction -->
                <div class="line line-margin" v-if="hide_head">
                    <div class="name">Parent / Guardian Consent</div>
                    <Switch :checked="is_need" @click.native="toggle" />
                </div>

                <template v-if="(hide_head && is_need) || !hide_head">

                    <div :class="['line',!handle_data[ind.introduction.i].is_switch && 'line-margin']">
                        <div class="name">{{handle_data[ind.introduction.i].name}}</div>
                        <Switch :checked="handle_data[ind.introduction.i].is_switch" @click.native="handle_data[ind.introduction.i].is_switch = !handle_data[ind.introduction.i].is_switch" />
                    </div>

                    <Field v-if="handle_data[ind.introduction.i].is_switch" :type="handle_data[ind.introduction.i].question[ind.introduction.ii].client_view.client_type"
                        :k="handle_data[ind.introduction.i].question[ind.introduction.ii].label"
                        :placeholder="handle_data[ind.introduction.i].question[ind.introduction.ii].client_view.plac"
                        @update="update"
                        :had_value="handle_data[ind.introduction.i].question[ind.introduction.ii].client_view.val" />
                    <div class="hr" style="margin: 16px 0; height: 0px; overflow: hidden; border-top: 1px solid var(--border);"></div>
                    <div class="desc">Please indicate which of the following parent / guardian information you'd like to include on your application for applicants under 18.</div>

                    <!-- All -->
                    <div class="edit-item" v-for="(v, k) in handle_data.filter(e=>{return e.tag !=='for_confirm' && e.tag !=='for_introduct' && e.tag !=='for_url' })" :key="k">
                        <div class="line">
                            <div class="name">{{ v.name }}<div class="red" v-if="v.is_required">*</div></div>
                            <div class="desc" style="flex: none;" v-if="v.setting_number === 1">Default</div>
                            <div class="handle_req" v-else>
                                <div class="req-box" v-if="v.setting_number===3 && v.is_switch" @click=" v.is_required = !v.is_required" >
                                    <Checkbox :checked="v.is_required" />
                                    Required
                                </div>
                                <Switch :checked="v.is_switch" @click.native="hanleAllQus(v)" />
                            </div>
                        </div>
                    </div>

                    <div class="hr" style="margin: 16px 0; height: 0px; overflow: hidden; border-top: 1px solid var(--border);"></div>

                    <div class="url-box">
                        <div class="url-box-content">
                            <div class="title">Parent & guardian disclaimer<span class="red">*</span></div>
                            <Field :type="'text'" :k="'disclaimer_url'" :placeholder="'https://www.website.com'" @update="update" :had_value="temp_data.disclaimer_url"/>
                            <div class="err-msg-box" v-if="err_mes.disclaimer_url">
                                <p class="err-msg" v-html="err_mes.disclaimer_url"></p>
                                <i><svg-icon name="alert" class="icon-left" /></i>
                            </div>
                        </div>
                        <div class="url-box-content">
                            <div class="title">Parent & guardian terms link<span class="red">*</span></div>
                            <Field :type="'text'" :k="'policy_url'" :placeholder="'https://www.website.com'" @update="update" :had_value="temp_data.policy_url"/>
                            <div class="err-msg-box" v-if="err_mes.policy_url">
                                <p class="err-msg" v-html="err_mes.policy_url"></p>
                                <i><svg-icon name="alert" class="icon-left" /></i>
                            </div>
                        </div>
                    </div>

                </template>
            </div>
        </div>
    </div>

    <!-- save -->
    <div class="save-btn-box" v-if="!hide_head">
        <el-button type="primary" size="large" class="save-btn" :disabled="disabled_save" @click="save()">Save</el-button>
    </div>

    <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
        <div class="box">
            <header class="delete-header">Remove parent / guardian consent from application?</header>
            <p>Applicants under 18 will no longer be able to view any questions that fall under this section. To make visible again, click + SECTION or update your Application Settings.</p>
            <div class="btns">
                <el-button @click="is_show_alert_modal = false">No</el-button>
                <el-button type="primary" @click="is_show_alert_modal = false; emit('hide'); close()">Confirm</el-button>
            </div>
        </div>
    </Modal>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Modal from '@/components/ui/Modal.vue';
import Switch from '@/components/ui/Switch.vue';
import Field from '@/components/ui/Field.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import { getIndex, handleParentUrl } from '@/utils/ProgramsData.js';
import { ElButton } from 'element-plus';

const props = defineProps({
    hide_head: { type: Boolean, default: false },
    is_need: { type: Boolean, default: true },
    data: { type: Array, default: () => [] },
    is_edit: { type: Boolean, default: false },
    pro_title: { type: String, default: '' },
});

const emit = defineEmits(['close', 'save', 'hide', 'update']);

const store = useStore();

const handle_data = ref([]);
const temp_data = reactive({
    parent_guardian_introduction: '',
    disclaimer_url: '',
    policy_url: '',
});
const err_mes = reactive({
    disclaimer_url: '',
    policy_url: '',
});
const ind = reactive({
    introduction: { i: 0, ii: 0 },
    disclaimer_url: { i: 0, ii: 0 },
    policy_url: { i: 0, ii: 0 },
});
const is_show_alert_modal = ref(false);

const brand_name = computed(() =>
    store.state.user_data?.merchant_account?.merchant_display_name
);

const disabled_save = computed(() =>
    err_mes.disclaimer_url || err_mes.policy_url || !temp_data.disclaimer_url || !temp_data.policy_url
);

const toggle = () => {
    if (props.is_need) {
        is_show_alert_modal.value = true;
    } else {
        emit('hide');
    }
};

const hanleAllQus = (v) => {
    v.is_switch = !v.is_switch;
    v.is_required = !v.is_switch ? false : v.is_required;
    if (!v.is_switch) {
        v.question.forEach(e => {
            e.client_view.show = false;
            e.client_view.is_required = false;
        });
    }
};

const isValidUrl = (string) => {
    const url_pattern = /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
    return url_pattern.test(string);
};

const update = (obj) => {
    Object.keys(temp_data).forEach(key => {
        if (key === obj.key) temp_data[key] = obj.val;
    });

    if (obj.key === 'disclaimer_url' || obj.key === 'policy_url') {
        err_mes[obj.key] = '';
        if (obj.val && !isValidUrl(obj.val)) {
            err_mes[obj.key] = `The url format is incorrect.`;
        }
    }

    emit('update', save(true));
};

const setDate = () => {
    handle_data.value[ind.introduction.i].question[ind.introduction.ii].client_view.val =
        temp_data.parent_guardian_introduction || handle_data.value[ind.introduction.i].question[ind.introduction.ii].client_view.plac;
    handle_data.value[ind.disclaimer_url.i].question[ind.disclaimer_url.ii].client_view.val = temp_data.disclaimer_url;
    handle_data.value[ind.policy_url.i].question[ind.policy_url.ii].client_view.val = temp_data.policy_url;
    handleParentUrl(handle_data.value, brand_name.value, props.pro_title);
};

const save = (is_return = false) => {
    setDate();
    if (is_return) {
        return handle_data.value;
    } else {
        emit('save', { data: handle_data.value, type: 'parent_guardian_consent' });
    }
};

const close = () => emit('close');

defineExpose({ save });

onMounted(() => {
    if (props.data.length > 0) {
        Object.assign(ind, {
            introduction: getIndex(props.data, 'parent_guardian_introduction', 'parent_guardian_introduction'),
            disclaimer_url: getIndex(props.data, 'parent_guardian_read_acknowledge_disclaimer_url', 'parent_guardian_read_acknowledge_disclaimer_url'),
            policy_url: getIndex(props.data, 'parent_guardian_read_and_acknowledge_terms_conditions_and_privacy_policy_url', 'parent_guardian_read_and_acknowledge_terms_conditions_and_privacy_policy_url'),
        });
        handle_data.value = JSON.parse(JSON.stringify(props.data));
        temp_data.parent_guardian_introduction = handle_data.value[ind.introduction.i].question[ind.introduction.ii].client_view.val;
        temp_data.disclaimer_url = handle_data.value[ind.disclaimer_url.i].question[ind.disclaimer_url.ii].client_view.val;
        temp_data.policy_url = handle_data.value[ind.policy_url.i].question[ind.policy_url.ii].client_view.val;
    }
});
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.edit_parent_header {
    @include flexCenter();
    justify-content: space-between;

    .ui-switch{
        margin-right: 40px;
    }
}

.edit-parent-box {

    .handle_req{
        font: var(--font-med-12);
        @include flexCenter();

        .req-box{
            @include flexCenter();
            margin-right: 8px;
            cursor: pointer;
        }
        .ui-checkbox{
            margin:unset;
        }
    }

    .line{
        @include flexCenter();
        justify-content: space-between;
        width: 100%;

        &.line-margin{
            margin-bottom: 16px;
        }
    }

    .name {
        font: var(--font-med-16);
        @include flexCenter();
        flex: 1;
    }

    .desc{
        margin-top: 8px;
    }

    .url-box{
        padding: 16px 0;

        .url-box-content{
            margin-top: 8px;

            &:first-child{
                margin-top: 0;
            }

            .title{
                font:var(--font-med-14);
            }

            .ui-input{
                margin: 4px 0 0 0;
            }
        }

        .err-msg-box{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color:var(--alert);

            i{
                width: 14px;
                height: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
            }

            svg{
                width: 10.5px;
                height: 10.5px;
                fill:var(--alert);
            }
        }
    }


}


.add-creator-modal .alert-modal header {
    padding: 0;
    height: auto;
    text-align: left;
    border: none;
}
</style>
